var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ad-account-list" } }, [
    _c("div", { staticClass: "mi-aal-header" }, [
      _c("strong", { staticStyle: { color: "#1f1f1f", "font-size": "14px" } }, [
        _vm._v(_vm._s(_vm.$t("metaInsights.selectAdAccount"))),
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { color: "#6b7280", "font-size": "12px" } }, [
        _vm._v(_vm._s(_vm.$t("metaInsights.selectAdAccountDesc"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mi-aal-list" },
      [
        _vm._l(_vm.accounts, function (acc) {
          return _c(
            "div",
            {
              key: acc.id,
              staticClass: "mi-aal-row",
              class: { "mi-aal-selected": _vm.isSelected(acc) },
              on: {
                click: function ($event) {
                  return _vm.select(acc)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "mi-aal-radio",
                  class: { "mi-aal-radio-checked": _vm.isSelected(acc) },
                },
                [
                  _vm.isSelected(acc)
                    ? _c("span", { staticClass: "mi-aal-dot" })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mi-aal-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "mi-aal-name",
                    staticStyle: {
                      "font-weight": "600",
                      "font-size": "14px",
                      color: "#1f1f1f",
                      "line-height": "1.4",
                      "word-break": "break-word",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(acc.name || acc.id) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mi-aal-badges" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mi-aal-badge",
                      staticStyle: {
                        background: "#f0f0f0",
                        color: "#595959",
                        "font-family":
                          "ui-monospace, SFMono-Regular, monospace",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(acc.account_id) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "mi-aal-badge",
                      staticStyle: { background: "#fff7e6", color: "#d48806" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(acc.currency) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  acc.business && acc.business.name
                    ? _c(
                        "span",
                        {
                          staticClass: "mi-aal-badge",
                          staticStyle: {
                            background: "#eef4ff",
                            color: "#1f6feb",
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "12px" },
                            },
                            [_vm._v("business")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(acc.business.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  acc.timezone_name
                    ? _c(
                        "span",
                        {
                          staticClass: "mi-aal-badge",
                          staticStyle: {
                            background: "#f6ffed",
                            color: "#389e0d",
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "12px" },
                            },
                            [_vm._v("schedule")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(acc.timezone_name) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        !_vm.accounts || _vm.accounts.length === 0
          ? _c("div", { staticClass: "mi-aal-empty" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("metaInsights.noAdAccounts")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }